import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'

import { useToast } from '@/components/ui'
import { projectService } from '@/services/http/projectService'

export const useGetPortfolios = ({
  enabled = false,
}: {
  enabled?: boolean
}) => {
  const { toast } = useToast()

  const { data, isError, isLoading, refetch } = useQuery({
    queryKey: ['portfolios'],
    queryFn: () => projectService.portfolio.get(),
    enabled,
  })

  useEffect(() => {
    if (isError)
      toast({
        title: 'Erro ao carregar o portfólio',
        variant: 'destructive',
      })
  }, [isError, toast])

  if (data) {
    const { portfolios } = data
    return {
      portfolios,
      isLoading,
      refetchPortfolio: refetch,
    }
  }

  return {
    portfolios: [],
    isLoading,
    refetchPortfolio: refetch,
  }
}
